import Vue from "vue";
import Vuex from "vuex";
import { DateTime } from "luxon";

// Saves store state to localStorage
import createPersistedState from "vuex-persistedstate";

// Util functions
import { generateUUID } from "./assets/utils";

//Remove old vuex
let vuex = JSON.parse(localStorage.getItem("vuex"));

if (vuex && vuex.length == undefined) {
  localStorage.removeItem("vuex");
}

Vue.use(Vuex);

const state = [];

class Webchat {
  constructor(data = {}) {
    this.isMobile = data.isMobile || false;
    this.isIOS = data.isIOS || false;
    this.isLowRes = data.isIOS || false;
    this.currentURL = data.currentURL || "";
    this.isInCall = data.isInCall || false;
    this.menu = data.menu || {
      menu_title: "",
      menu_img: "",
    };
    this.configuration = data.configuration || {
      ip: "",
      campaign: "",
    };
    this.campaign = data.campaign || {
      onTime: false,
      messages: {
        es: "",
        en: "",
        pt: "",
      },
      feedback: "",
      logo: 0,
      logoName: "",
      name: "",
    };
    this.client = data.client || {
      lang: "",
      guid: "",
      name: "",
      mail: "",
      number: "",
      initialMessage: "",
      typingText: "",
      rating: 0,
      sendmail: false,
      surveyMessage: "",
      ipAddress: "",
      data: "",
      accessibility: { fontSize: 0 },
    };
    this.interaction = data.interaction || {
      active: false,
      //con notstarted va a mostrar el form de iniciar
      //con waiting va a mostrar el rejoj
      //started va a mostrar el chat
      //finishged va a mostrar el survey
      // !!!!! notstarted, waiting, started, finished
      state: "notstarted",
      transfering: false,
      messages: [],
      unreadMessages: 0,
      guid: "",
      agent: "",
      holdTime: 0,
      telAgent: "",
      endConv: false,
      lastActiveTime: null,
    };
    this.notifications = data.notifications || {
      notifications: true,
    };
    this.open = data.open || true;
    this.isExternalWindow = data.isExternalWindow || false;
    this.firstMessageDisplayed = data.firstMessageDisplayed || false;
    this.lastOneMe = data.lastOneMe || null;
    this.lastOneAgent = data.lastOneAgent || null;
  }
}

const mutations = {
  startTransfering(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.transfering = true;
  },
  updateVuex(state, newState) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    Object.keys(newState).forEach((key) => {
      if (newState[key].interaction.active) {
        state[key].interaction = newState[key].interaction;
        state[key].client = newState[key].client;
      }
    });
  },
  endTransfering(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.transfering = false;
  },

  changeLastActiveTime(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.lastActiveTime = value;
  },

  changeFirstMessageDisplayed(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].firstMessageDisplayed = !state.firstMessageDisplayed;
  },

  changeTitle(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].menu.menu_title = param;
  },

  changeImage(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].menu.menu_img = param;
  },

  addConfiguration(state, payload) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    let ip = state[index].configuration.ip;
    let campaign = state[index].configuration.campaign;

    state[index].configuration = payload.param;

    if (!state[index].configuration.ip) state[index].configuration.ip = ip;
    if (!state[index].configuration.campaign)
      state[index].configuration.campaign = campaign;
  },

  setOnTime(state, payload) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].campaign = payload.param;

    // Setting Title depending on payload
    if (!state[index].campaign.onTime) {
      state[index].menu.menu_title = "Offline";
    }
  },

  setFeedback(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].feedback = value;
  },

  setIpAddress(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.ipAddress = value;
  },

  isMobile(state, mobile) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].isMobile = mobile;
  },

  isIOS(state, ios) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].isIOS = ios;
  },

  isLowRes(state, isLow) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].isLowRes = isLow;
  },

  currentURL(state, URL) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].currentURL = URL;
  },

  setNameClient(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.name = param;
  },

  setEmailClient(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.mail = param;
  },

  setNumberClient(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.number = param;
  },

  setAccessibilityFontSize(state, size) {
    const campaignName = window.location.hash
      .substring(window.location.hash.indexOf("campaign="))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    if (!state[index].client.accessibility) {
      state[index].client.accessibility = new Object();
    }

    state[index].client.accessibility.fontSize = size;
  },

  setInitialMessageClient(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.initialMessage = param;
  },

  changeGuidInteraction(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.guid = param;
  },

  changeHoldTime(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.holdTime = param;
  },

  waitingInteraction(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.state = "waiting";
    state[index].interaction.active = true;
    state[index].configuration.name = "";
    state[index].configuration.mail = "";
    state[index].configuration.initialMessage = "";
  },

  connectedInteraction(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.state = "started";
  },

  finishedInteraction(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.state = "finished";
    state[index].interaction.active = false;
    state[index].interaction.transfering = false;
    state[index].interaction.lastActiveTime = null;
    state[index].configuration.name = "";
    state[index].configuration.mail = "";
    state[index].configuration.initialMessage = "";
  },

  noStartedInteraction(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.state = "notstarted";
    state[index].interaction.active = false;
    state[index].interaction.transfering = false;
  },

  nameImage(state, name) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].menu.menu_img =
      "https://" +
      state[index].configuration.ip +
      "/images/" +
      name.replace(/\s+/g, "") +
      ".jpg";
  },

  nameAgent(state, param) {
    if (param) {
      const campaignName = window.location.hash
        .split("&")
        .find((h) => h.includes("campaign"))
        .split("=")[1];

      const index = state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      state[index].menu.menu_title = param;
      state[index].interaction.agent = param;
    }
  },

  telAgent(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.telAgent = param;
  },

  username(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.username = param;
  },

  newMessage(state, message) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    message.date = DateTime.fromJSDate(new Date()).toFormat("HH:mm");

    if (message.self) {
      if (state[index].lastOneMe) {
        state[index].lastOneMe.lastOne = false;
      }
      state[index].lastOneMe = message;
    } else {
      if (state[index].lastOneAgent) {
        state[index].lastOneAgent.lastOne = false;
      }
      state[index].lastOneAgent = message;
    }

    //si el mensaje no es del cliente (es del agente) o es algo que no es un numero, lo meto en el array

    let position = state[index].interaction.messages.push(message);

    message.position = position - 1;
    message.optionClicked = false;
  },

  updateMessage(state, message) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.messages[message.position] = message;
  },

  clearInteraction(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.messages = [];
    state[index].interaction.guid = "";
    state[index].interaction.agent = "";
    state[index].interaction.holdTime = 0;
    state[index].interaction.telAgent = "";
    state[index].menu.menu_title = "";
  },

  newGuid(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.guid = generateUUID();
  },

  setTypingText(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.typingText = param;
  },

  clearMessage(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.typingText = "";
  },

  setRatingValue(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.rating = value;
  },

  setSendMail(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.sendmail = value;
  },

  setIsInCall(state, value) {
    const campaignName = window.location.hash
      .substring(window.location.hash.indexOf("campaign="))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].isInCall = value;
  },

  setSurveyMessage(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.surveyMessage = value;
  },

  setNotifications(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].notifications.notifications = value;
  },

  setLang(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    let index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    if (index === -1) {
      state.push(new Webchat());
      state.at(-1).configuration.campaign = campaignName;

      index = state.findIndex((e) => e.configuration.campaign === campaignName);
    }

    state[index].client.lang = value;
  },

  setOffline(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].campaign.timeOut = true;
  },

  clearInitialMessage(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.initialMessage = "";
  },

  clearSurveyMessage(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.surveyMessage = "";
  },

  clearCalification(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.rating = 0;
  },

  setEventState(state, value) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].eventState = value;
  },

  setClientInfo(state, param) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].client.name = param.name;
    state[index].client.mail = param.mail;
    state[index].client.number = param.number;
    state[index].client.initialMessage = param.initialMessage;
    state[index].client.data = param.data;
  },

  toggleOpen(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].open = !state.open;
  },

  restartUnreadedMessagesCounter(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.unreadMessages = 0;
  },

  addOneUnreadedMessagesCounter(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.unreadMessages++;
  },

  changeIsExternalWindow(state, isExtenal) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].isExternalWindow = isExtenal;
  },

  interactionFinished(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].interaction.active = false;
    state[index].interaction.transfering = false;
    state[index].firstMessageDisplayed = !state.firstMessageDisplayed;
  },

  setCampaignLogo(state, logo) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].campaign.logo = logo;
  },

  setCampaignLogoName(state, name) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].campaign.logoName =
      "https://" +
      state[index].configuration.ip +
      "/images/" +
      name.replace(/\s+/g, "") +
      ".jpg";
  },

  setTurnConf(state, turnConf) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].turnConf = turnConf;
  },

  setTelephonyServer(state, telephonyServer) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].telephonyServer = telephonyServer;
  },
};

const actions = {
  increment: ({ commit }) => commit("increment"),

  decrement: ({ commit }) => commit("decrement"),

  incrementIfOdd({ commit, state }) {
    if ((state.count + 1) % 2 === 0) {
      commit("increment");
    }
  },

  incrementAsync({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit("increment");
        resolve();
      }, 1000);
    });
  },
};

const getters = {
  hasImageMenuTitle: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].menu.menu_img !== "";
  },
  getLastActiveTime: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].interaction.lastActiveTime;
  },
  getClassColorStatus: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    if (state[index].campaign.onTime) return "avaiablecolor";
    else return "unavaiablecolor";
  },

  isWaitingInteraction: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].interaction.state === "waiting";
  },

  isStartedInteraction: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].interaction.state === "started";
  },

  hasTextareaText: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].client.typingText.trim() !== "";
  },

  messages: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].interaction.messages;
  },

  imageAgent: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    state[index].menu.menu_title !== "Chat";
  },

  getMainTitle: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );
    if (state[index].menu.menu_title) return state[index].menu.menu_title;
    else {
      if (state[index].campaign.onTime) return "Chat";
      else return "Offline";
    }
  },

  turnConf: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].turnConf;
  },

  telephonyServer: (state) => {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    return state[index].telephonyServer;
  }
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState()],
});
